import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle, faTimes} from '@fortawesome/free-solid-svg-icons';
import i18next from 'i18next';

class ResetPasswordSuccess extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      windowWidth: 0,
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.update = this.update.bind(this);
    window.addEventListener('resize', this.update);
  }

  componentDidMount() {
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update);
  }

  toggleShow() {
    this.setState({hidden: !this.state.hidden});
  }

  update() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  userLogin() {
    this.props.history.push({
      pathname: '/login',
      state: {show: true}});
  }

  render() {
    const {windowWidth} = this.state;
    return (
      <React.Fragment>
        {windowWidth > 767 ?
                    <div className={'reset-password-success-desktop'}>
                      <div>
                        <div className={'header-popup flex space-between '}>
                          <p id={'test1'} className={'p0 m-0 accent-color'}>{i18next.t('Imposta nuova password')}</p>
                          <div>
                            <FontAwesomeIcon icon={faTimes}
                              className={'light-grey pointer'}
                              onClick={() => this.props.history.push('/')}
                            />
                          </div>
                        </div>
                        <div className={'body-popup controla-email center'}>
                          <FontAwesomeIcon icon={faCheckCircle} className={'check-circle'} />
                          <p id={'test2'} className={'ptb-10 mb-10'}>{i18next.t('Password salvata correttamente!')}</p>

                          <div className={'button-wrapper mb-10'}>
                            <div className={'button'}
                              onClick={() => this.userLogin()}
                            >{i18next.t('LOGIN')}</div>
                          </div>
                          <div className={'button-wrapper password4'}>
                            <div
                              className={'button pink-bg white'} id={'test-button'}
                              onClick={() => this.props.history.push('/')}
                            >{i18next.t('ESCI')}</div>
                          </div>
                        </div>
                      </div>
                    </div> :
                    <div className={'reset-password-success-mobile'}>
                      <div>
                        <div className={'header-popup flex space-between '}>
                          <p id={'test1'} className={'p0 m-0 light-grey p20'}>{i18next.t('Imposta nuova password')}</p>
                          <div>
                            <FontAwesomeIcon icon={faTimes}
                              className={'light-grey pointer'}
                              onClick={() => this.props.history.push('/')}
                            />
                          </div>
                        </div>
                        <div className={'body-popup controla-email center '}>
                          <FontAwesomeIcon icon={faCheckCircle} className={'check-circle'} />
                          <p id={'test2'} className={'ptb-10 mb-10'}>{i18next.t('Password salvata correttamente!')}</p>

                          <div className={'button-wrapper mb-10'}>
                            <div className={'button'}
                              onClick={() => this.userLogin()}
                            >{i18next.t('LOGIN')}</div>
                          </div>
                          <div className={'button-wrapper'}>
                            <div className={'button p14 pink-bg white'}
                              id={'test-button-mob'}
                              onClick={() =>
                                this.props.history.push('/')}
                            >{i18next.t('ESCI')}</div>
                          </div>
                        </div>

                        <div className={'footer-popup '}>
                          <p className={'p0'}>{i18next.t('Non hai ricevuto l\'email? Contatta')}{' '}<span>{i18next.t('l\'assistenza')}</span></p>
                        </div>
                      </div>
                    </div>
        }
      </React.Fragment>
    );
  }
}

export default ResetPasswordSuccess;
